import { Vehicle, GeotabSensor, Key } from "../../../../../models";
import { Actions, createNamespace } from "../../../../../flux";
import { Measures } from "../../../../../rest/Misc";

const ns = createNamespace('EDIT_SENSOR');
export const names = {
    SET_VEHICLE: ns('SET_VEHICLE'),
    SET_GEOTAB: ns('SET_GEOTAB'),
    SET_DISPLAY: ns('SET_DISPLAY'),
    SET_QUANTITY_UNIT: ns('SET_QUANTITY_UNIT'),
    SET_ABS_RED_MAX: ns('SET_ABS_RED_MAX'),
    SET_ABS_RED_MIN: ns('SET_ABS_RED_MIN'),
    SET_ABS_YELLOW_MAX: ns('SET_ABS_YELLOW_MAX'),
    SET_ABS_YELLOW_MIN: ns('SET_ABS_YELLOW_MIN'),

    SET_BASELINE: ns('SET_BASELINE'),
    SET_REL_RED_MAX: ns('SET_REL_RED_MAX'),
    SET_REL_RED_MIN: ns('SET_REL_RED_MIN'),
    SET_REL_YELLOW_MAX: ns('SET_REL_YELLOW_MAX'),
    SET_REL_YELLOW_MIN: ns('SET_REL_YELLOW_MIN'),

    SET_VEHICLES_ITEMS: ns('SET_VEHICLES_ITEMS'),
    SET_GEOTAB_SENSORS_ITEMS: ns('SET_GEOTAB_SENSORS_ITEMS'),
    SET_MEASURE_ITEMS: ns('LOAD_MEASURES'),
};

export class EditSensorActions extends Actions
{
    setVehicle = (vehicleId: Key) => this.dispatch(names.SET_VEHICLE, vehicleId);
    setVehicleItems = (vehicles: Vehicle[]) => this.dispatch(names.SET_VEHICLES_ITEMS, vehicles);
    
    setGeotabSensor = (sensor: GeotabSensor) => this.dispatch(names.SET_GEOTAB, sensor);
    setGeotabSensorsItems = (sensors: GeotabSensor[]) => this.dispatch(names.SET_GEOTAB_SENSORS_ITEMS, sensors);

    setQuantity = (quantityId: number, unitId: number) => this.dispatch<MeasurePair>(names.SET_QUANTITY_UNIT, { quantityId, unitId });
    setMeasures = (measures: Measures) => this.dispatch(names.SET_MEASURE_ITEMS, measures);

    setAbsRedMax = (value: number) => this.dispatch(names.SET_ABS_RED_MAX, value);
    setAbsRedMin = (value: number) => this.dispatch(names.SET_ABS_RED_MIN, value);
    setAbsYellowMax = (value: number) => this.dispatch(names.SET_ABS_YELLOW_MAX, value);
    setAbsYellowMin = (value: number) => this.dispatch(names.SET_ABS_YELLOW_MIN, value);
    setDisplay = (value: string) => this.dispatch(names.SET_DISPLAY, value);
    
    setBaseline = (value: number) => this.dispatch(names.SET_BASELINE, value);
    setRelRedMax = (value: number) => this.dispatch(names.SET_REL_RED_MAX, value);
    setRelRedMin = (value: number) => this.dispatch(names.SET_REL_RED_MIN, value);
    setRelYellowMax = (value: number) => this.dispatch(names.SET_REL_YELLOW_MAX, value);
    setRelYellowMin = (value: number) => this.dispatch(names.SET_REL_YELLOW_MIN, value);
}

export interface MeasurePair
{
    quantityId: number;
    unitId: number;
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/flux/EditSensorActions.ts